import $ from 'jquery';

export default function heroScroll() {
  $('.scroll-down').click(function () {
    const headerHeight = $('.header').outerHeight(true);

    $('html,body').animate({ scrollTop: $(this).closest('.block-hero').next().offset().top - headerHeight }, 'slow');
  });
}
